export class Dossier{
    id = 0
    nomDossier = ''
    dossiersEnfant : Dossier[] = []
    dossierParentId : null | number = null
    visibleSiteVitrine = false
    visibleAgentOrtho = false
    visibleAgentDentaire = false
    visibleClientOrtho = false
    visibleClientDentaire = false
    visibleCodir = false
    visibleADV = false
    dossierParentVisibleSiteVitrine = false
    dossierParentVisibleAgentOrtho = false
    dossierParentVisibleAgentDentaire = false
    dossierParentVisibleClientOrtho = false
    dossierParentVisibleClientDentaire = false
    dossierParentVisibleCodir = false
    dossierParentVisibleADV = false
}